export const TIBO_CHART_PALETTE = {
  primary: '#4F46E5', // indigo-600
  secondary: '#06B6D4', // cyan-500
  ai: '#8B5CF6', // violet-500
  success: '#059669', // emerald-600
  danger: '#E11D48', // rose-600
  warning: '#F59E0B', // warning-500
  info: '#0EA5E9', // sky-500
  neutral: '#94A3B8', // slate-400
};

/**
 * Channel identity colors. Validated for CVD separation (ΔE 16.1 protan) and
 * ≥3:1 contrast against both the light (#FFFFFF) and dark (#1E293B) card surfaces.
 */
export const TIBO_CHANNEL_COLORS: Record<'whatsapp' | 'telegram', string> = {
  whatsapp: '#059669', // success-600
  telegram: '#0284C7', // info-600
};

/**
 * CRM series colors. `conversations` is the same entity in every chart, so it
 * keeps the same hue. primary-500 clears 3:1 on both card surfaces (primary-600
 * does not, in dark).
 */
export const CRM_SERIES_COLOR = {
  conversations: '#6366F1', // primary-500
} as const;

export const TIBO_CHART_SERIES = [
  TIBO_CHART_PALETTE.primary,
  TIBO_CHART_PALETTE.secondary,
  TIBO_CHART_PALETTE.ai,
  TIBO_CHART_PALETTE.success,
  TIBO_CHART_PALETTE.info,
  TIBO_CHART_PALETTE.warning,
];

/**
 * Color de las líneas de tendencia. Ámbar, distinto de la serie que acompañan.
 *
 * Validado con el script del skill de visualización contra `#6366F1`, que es el
 * color de las series de CRM: ΔE 32,2 en protanopia y 35,1 en visión normal,
 * y contraste ≥3:1 sobre las dos superficies. `#F59E0B` —un paso más claro—
 * separa mejor pero queda en 2,09 de contraste, así que se descartó.
 */
export const TREND_COLOR = '#D97706'; // warning-600
